export var PaddingSizes;
(function (PaddingSizes) {
    PaddingSizes["None"] = "none";
    PaddingSizes["Large"] = "large";
    PaddingSizes["Medium"] = "medium";
    PaddingSizes["Small"] = "small";
    PaddingSizes["ExtraSmall"] = "extra-small";
    PaddingSizes["ExtraExtraSmall"] = "extra-extra-small";
})(PaddingSizes || (PaddingSizes = {}));
//# sourceMappingURL=paddings.js.map